import { Dialog, DialogContent } from "@/components/ui";
import { EmailLoginContent } from "../email-login-content";
import { useAuthState } from "@/store/auth";
import { DialogCloseIcon } from "@/components/shared/dialog-close";

export const EmailLoginModal = () => {
  const {
    data: { emailLoginModalOpen },
    showModal,
  } = useAuthState();
  const onClose = () => {
    showModal();
  };
  return (
    <Dialog open={emailLoginModalOpen}>
      <DialogContent className="w-[343px]">
        <DialogCloseIcon onClose={onClose} />
        <EmailLoginContent />
      </DialogContent>
    </Dialog>
  );
};
